export const checkIsMobile = () => {
  const ua = navigator.userAgent;

  // 1. 기기 종류로 판별
  const isMobileDevice =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);

  // 2. iPad 판별 (PC와 구분)
  const isIPad =
    /iPad/i.test(ua) || (navigator.maxTouchPoints > 0 && /Macintosh/i.test(ua));

  // 3. 화면 크기 구분
  const isSmallWindow = window.innerWidth <= 700;

  return isMobileDevice || isIPad || isSmallWindow;
};
